module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/invoice_payments/download_report', 'Invoices_payments.xlsx')
            }
          }
        }, [_vm._v("Export Selection")])], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privUser) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n        ")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.overview.runBatch(_vm.sendEmail, 'id')
            }
          }
        }, [_vm._v("Send Payment Confirmation")])], 2) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Contract/Student",
      "field": "contract_id",
      "optionListApiUrl": '/contracts/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    attrs: {
      "label": "Email Sent",
      "field": "email_sent",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-4",
    attrs: {
      "label": "Payment date after",
      "type": "date",
      "field": "payment_after",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ced490"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/InvoicePayment/Overview.vue
// module id = 701
// module chunks = 1